"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerFeedbackAggregableData = void 0;
class CustomerFeedbackAggregableData {
    originLocationName;
    destinationLocationName;
    departureAt;
    locationNames;
    feedback;
    driverName;
    profilePhoto;
}
exports.CustomerFeedbackAggregableData = CustomerFeedbackAggregableData;
//# sourceMappingURL=CustomerFeedbackAggregableData.js.map